import { schema as schemas } from 'normalizr'
import { CallApi } from '@signavio/kraken'
import qs from 'qs'

import { schema as commentSchema } from './comment'

export { collection } from './comment'

export const schema = new schemas.Array(commentSchema)

type FetchPropsTypes = {
  caseId: string
  taskId?: string
}

export const fetch =
  (callApi: CallApi, apiBase: string) =>
  ({ caseId, taskId }: FetchPropsTypes) => {
    return callApi(
      `${apiBase}/cases/${caseId}/events${qs.stringify(
        {
          type: 'comment',
          taskId,
        },

        {
          addQueryPrefix: true,
        }
      )}`,
      schema
    )
  }
